<div class="score-detail-view">
  <div class="detail-section">
    <div>
      <label [for]="studentName">
        {{ 'shared-score-detail-field-student' | translate }}:
      </label>
      <span id="studentName" class="detail-value">
        {{studentName}}
      </span>
    </div>
    <div>
      <label [for]="className">
        {{ 'shared-score-detail-field-class' | translate }}:
      </label>
      <span id="className" class="detail-value">
        {{className}}
      </span>
    </div>
    <div>
      <label [for]="productName">
        {{ 'shared-score-detail-field-product' | translate }}:
      </label>
      <span id="productName" class="detail-value">
        {{productName}}
      </span>
    </div>
    <div>
      <label [for]="activityName">
        {{ 'shared-score-detail-field-activity' | translate }}:
      </label>
      <span id="activityName" class="detail-value">
        {{activityName}}
      </span>
    </div>
  </div>
  <div *ngIf="!showSpinner; else preloader;" class="score-table">
    <zbp-data-table
      [columns]="columns"
      [rows]="rows"
      [colorPrint]="true"
      [printableHeaders]="printableHeaders"
    />
  </div>

  <ng-template #preloader>
    <div class="preloader spinner">
      <zbp-preloader></zbp-preloader>
    </div>
  </ng-template>
</div>
